// Utils
import { throttle } from 'ezyvet-fe-helpers';
import { TooltipSyntheticEventNames } from '../types/TooltipSyntheticEventNames';
/**
 * Utilised by openTooltip. This reduces the number of open events from being dispatched.
 * Use openTooltip() over this
 *
 * @see /react-ui/src/display/Tooltip/utils/openTooltip.ts Preferred way of opening a tooltip
 * */
export var openTooltipThrottled = throttle(function (subscribedTooltipEventElement, x, y, contentData, getContent) {
    return subscribedTooltipEventElement.dispatchEvent(new CustomEvent(TooltipSyntheticEventNames.Open, {
        detail: { x: x, y: y, contentData: contentData, getContent: getContent },
    }));
}, 50);
//# sourceMappingURL=openTooltipThrottled.js.map